import LearnArabic from "../images/Learn-Arabic.PNG";

import portfolio from "../images/facebook_cover_photo_2.png";

export const Data = [
  {
    id: 1,
    name: "Learn Arabic",
    img: LearnArabic,
    stack: ["JavaScript", "React", "NodeJs", "Express", "Prisma", "PostgreSQL"],
    pathTo: "/learnArabic",
    href: "https://main--gatewaytoarabicproject.netlify.app/",
  },
  {
    id: 2,
    name: "My Portfolio",
    img: portfolio,
    stack: ["React"],
    pathTo: "/portfolio",
    href: "https://safia-ibrahim.netlify.app/",
  },
];
